export const DEFAULT_CLOSE_STROKE_JOIN = "bevel";
//# sourceMappingURL=line-stroke.js.map
